import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUsefulLinks, IUsefulLinksState } from "./usefullinksModel";
import {
  ActiveInactiveUsefulLinks,
  createUsefulLinks,
  deleteUsefulLinks,
  getAllActiveUsefulLinks,
  getAllUsefulLinks,
  getUsefulLinksByID,
  updateUsefulLinks,
} from "./services/usefullinks.services";

const initialState: IUsefulLinksState = {
  loading: false,
  error: "",
  UsefulLinksID: null,
  UsefulLinksList: [],
  UsefulLinksDetail: {
    Title: "",
    Description: "",
    WebsiteTitle: "",
    WebsiteLink: "",
    IsDisplayMain: false,
    IsActive: 1,
  },
};

const usefullinksSlice = createSlice({
  name: "usefullinks",
  initialState,
  reducers: {
    clearUsefulLinksDetails: (state) => {
      state.UsefulLinksDetail = initialState.UsefulLinksDetail;
    },
    setUsefulLinksID: (state, action) => {
      state.UsefulLinksID = action.payload;
    },
    clearUsefulLinksID: (state) => {
      state.UsefulLinksID = initialState.UsefulLinksID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllUsefulLinks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllUsefulLinks.fulfilled,
      (state, action: PayloadAction<IUsefulLinks[]>) => {
        state.loading = false;
        state.UsefulLinksList = action.payload || [];
      }
    );
    builder.addCase(getAllUsefulLinks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.UsefulLinksList = [];
    });
    builder.addCase(createUsefulLinks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createUsefulLinks.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createUsefulLinks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateUsefulLinks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateUsefulLinks.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateUsefulLinks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteUsefulLinks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteUsefulLinks.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteUsefulLinks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getUsefulLinksByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getUsefulLinksByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.UsefulLinksDetail = action.payload;
    });
    builder.addCase(getUsefulLinksByID.rejected, (state, action) => {
      state.loading = false;
      state.UsefulLinksDetail = initialState.UsefulLinksDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveUsefulLinks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveUsefulLinks.fulfilled,
      (state, action: PayloadAction<IUsefulLinks[]>) => {
        state.loading = false;
        state.UsefulLinksList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveUsefulLinks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.UsefulLinksList = [];
    });
    builder.addCase(ActiveInactiveUsefulLinks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveUsefulLinks.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveUsefulLinks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearUsefulLinksDetails, clearUsefulLinksID, setUsefulLinksID } =
  usefullinksSlice.actions;
export default usefullinksSlice.reducer;
